export const medialUrl = "https://images.rebelsoftt.com";
